export const CLEAR_HISTORY_MESSAGES = "CLEAR_HISTORY_MESSAGES";
export const SET_MINIMIZE_WINDOW = "SET_MINIMIZE_WINDOW";


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/request-processor-end-session/src/actions/actionTypes.js